export const WIDGET_BASE_HEIGHT = 10;
